import { HttpClient } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { ToastService } from "ng-uikit-pro-standard";
import { Observable, of, ReplaySubject, throwError } from "rxjs";
import { catchError, map, switchMap, take } from "rxjs/operators";
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { ParametroEmpresaService } from "src/app/services/parametro-empresa.service";
import { StorageVariable } from '../shared/object/local-storage-variable.enum';

@Injectable()
export class SignalRMessageService {
  private readonly _http: HttpClient;
  private produccion: boolean = true; //Determina en que ambiente se desarrolla
  private mensajeUrl: string | null = null;
  private readonly mensajeUrl$ = new ReplaySubject<string>(1);

  constructor(
    http: HttpClient,
    private parametroEmpresaService: ParametroEmpresaService,
    private messageRendererService: MessageRendererService,
    private toastService: ToastService,
  ) {
    this._http = http;
    // this.parametroEmpresaService.obtenerUrlMensaje(this.getRutEmpresa(), ({ respuesta, mensajes }) => {
    //   if (mensajes && mensajes.length > 0) {
    //     this.messageRendererService.showErrors(mensajes);
    //     return;
    //   }
    //   this.mensajeUrl = respuesta.valor;
    //   this.mensajeUrl$.next(this.mensajeUrl);
    // });
  }

  send(message: any): Observable<void> {
    if (this.existeProcesoPendiente(message)) {
      this.toastService.show(
        'Ya existe un proceso pendiente, espere que termine.',
        'Proceso pendiente',
        { position: 'top-right', duration: 10000, type: 'warning' }
      );
      return throwError(() => new Error('Ya existe un proceso pendiente'));
    };

    this.guardarProcesoSignal(message);

    if (!this.produccion) {
      const requestUrl = 'http://localhost:7048/api/message';
      return this.enviar(requestUrl, message);
    }

    return this.precargarUrlMensaje().pipe(
      take(1),
      switchMap((url) => this.enviar(url, message)),
      catchError((error) => {
        this.eliminarProcesoSignal({
          tipo_notificacion_codigo: message.tipo_notificacion_codigo,
          categoria_modulo_codigo: message.categoria_modulo_codigo,
        });
        return throwError(() => error);
      }),
    );

    // return new Observable<void>((observer) => {
    //   if (this.produccion) {
    //     this.parametroEmpresaService.obtenerUrlMensaje(this.getRutEmpresa(), ({ respuesta, mensajes }) => {
    //       if (mensajes && mensajes.length > 0) {
    //         this.messageRendererService.showErrors(mensajes);
    //         observer.error('Error al obtener la URL del mensaje');
    //         return;
    //       }
    //       let requestUrl = respuesta.valor;
    //       this._http.post(requestUrl, message, { responseType: 'text' }).subscribe(
    //         () => {
    //           observer.next(); // Emitir un valor vacío para indicar éxito
    //           observer.complete(); // Completar el observable
    //         },
    //         (error) => {
    //           console.error('Error al enviar el mensaje:', error);
    //           this.eliminarProcesoSignal({
    //             tipo_notificacion_codigo: message.tipo_notificacion_codigo,
    //             categoria_modulo_codigo: message.categoria_modulo_codigo
    //           });
    //           observer.error(error); // Emitir un error si falla la solicitud HTTP
    //         }
    //       );
    //     });
    //   } else {
    //     let requestUrl = 'http://localhost:7048/api/message';
    //     this._http.post(requestUrl, message, { responseType: 'text' }).subscribe(
    //       () => {
    //         observer.next(); // Emitir un valor vacío para indicar éxito
    //         observer.complete(); // Completar el observable
    //       },
    //       (error) => {
    //         console.error('Error al enviar el mensaje:', error);
    //         this.eliminarProcesoSignal({
    //           tipo_notificacion_codigo: message.tipo_notificacion_codigo,
    //           categoria_modulo_codigo: message.categoria_modulo_codigo
    //         });
    //         observer.error(error); // Emitir un error si falla la solicitud HTTP
    //       }
    //     );
    //   }
    // });
  }

  private precargarUrlMensaje(): Observable<string> {
    if (this.mensajeUrl) {
      // Ya cacheado: reaprovecha el valor
      this.mensajeUrl$.next(this.mensajeUrl);
      return this.mensajeUrl$.asObservable();
    }

    const rutEmpresa = this.getRutEmpresa();
    if (!rutEmpresa) return of('');

    this.parametroEmpresaService.obtenerUrlMensaje(rutEmpresa, ({ respuesta, mensajes }) => {
      if (mensajes && mensajes.length) {
        this.messageRendererService.showErrors(mensajes);
        this.mensajeUrl$.error(new Error('No fue posible obtener la URL del mensajero.'));
        return;
      }
      this.mensajeUrl = respuesta.valor;
      this.mensajeUrl$.next(this.mensajeUrl);
    });

    return this.mensajeUrl$.asObservable();
  }

  private enviar(url: string, message: any): Observable<void> {
    if (!url) return of(void 0);
    return this._http.post(url, message, { responseType: 'text' }).pipe(
      map(() => void 0),
      catchError((error) => {
        console.error('Error al enviar el mensaje:', error);
        this.eliminarProcesoSignal({
          tipo_notificacion_codigo: message.tipo_notificacion_codigo,
          categoria_modulo_codigo: message.categoria_modulo_codigo,
        });
        return throwError(() => error);
      }),
    );
  }

  // Helpers públicos para consultar bloqueos desde componentes
  public hasProcesoPendiente(entidad: { tipo_notificacion_codigo?: number; categoria_modulo_codigo?: number; }): boolean {
    if (!entidad) return false;
    const id = this.buildId(entidad.tipo_notificacion_codigo, entidad.categoria_modulo_codigo);
    return sessionStorage.getItem(`processSignal${id}`) !== null;
  }

  private buildId(tipo?: any, categoria?: any): string {
    const t = tipo ? tipo : '0';
    const c = categoria ? categoria : '0';
    return `${t}_${c}`;
  }

  private existeProcesoPendiente(params: any): boolean {
    const entidad = params.entidad;
    return this.hasProcesoPendiente(entidad);
  }

  private guardarProcesoSignal(params: any) {
    console.log('Verificando params', params);
    if (!params || !params.entidad) return;

    const tipo = params.entidad.tipo_notificacion_codigo;
    const categoria = params.entidad.categoria_modulo_codigo;
    // Si ambos campos vienen ausentes (undefined o null), no se guarda el proceso
    if (!tipo && !categoria) return;

    console.log('Guardando proceso signal', params);

    const processSignal = {
      rutUsuario: localStorage.getItem(StorageVariable.RUT_USUARIO),
      rutEmpresa: localStorage.getItem(StorageVariable.RUT_EMPRESA),
      tipoNotificacion: tipo,
      categoriaModulo: categoria,
    }
    const id = this.buildId(tipo, categoria);
    sessionStorage.setItem(`processSignal${id}`, JSON.stringify(processSignal, null, 2));
  }

  private eliminarProcesoSignal(data: {
    tipo_notificacion_codigo: number;
    categoria_modulo_codigo: number;
  }) {
    console.log('Eliminar proceso signal', data);
    const tipo = data.tipo_notificacion_codigo;
    const categoria = data.categoria_modulo_codigo;
    if (!tipo && !categoria) return;

    const id = this.buildId(tipo, categoria);
    console.log('Eliminar proceso signal', `processSignal${id}`);
    sessionStorage.removeItem(`processSignal${id}`);
  }

  private getRutEmpresa(): any {
    return localStorage.getItem(StorageVariable.RUT_EMPRESA);
  }
}
